import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initializeLogRocket } from './utils/logrocket'

// Initialize LogRocket monitoring before rendering the app
initializeLogRocket()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find root element. Make sure there is a <div id="root"></div> in your index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
